import { render, staticRenderFns } from "./documentosAnteriores.vue?vue&type=template&id=461b6c3e&scoped=true"
import script from "./documentosAnteriores.vue?vue&type=script&lang=js"
export * from "./documentosAnteriores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b6c3e",
  null
  
)

export default component.exports